<template>
  <div>
    <Navbar appTitle="发起返修" />
    <div class="search-content wrap-apply" :style="{top: GLOBAL.currentEnvironment ? '0' : '',height: GLOBAL.currentEnvironment ? '100vh' : 'calc(100vh - 1.12rem)',paddingBottom: GLOBAL.currentEnvironment ? '0.66rem' : ''}">
      <van-cell-group style="margin-top: 0.1rem">
        <p class="label FormTit"><span></span>工单编号</p>
        <van-field
          disabled
          v-model="repairForm.orderCode"
          placeholder="请输入"
        />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label FormTit"><span></span>生产物料</p>
        <van-field disabled v-model="repairForm.goodsName" />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label FormTit"><span></span>工序</p>
        <van-field disabled v-model="repairForm.processFullName" />
        <div class="bottomLine" style="margin-top:0.01rem"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label FormTit"><span></span>批次编号</p>
        <div style="padding:0.1rem 0.16rem"><batch-production :code="repairForm.batchCode" :id="repairForm.batchId"></batch-production></div>
        <div class="bottomLine" style="margin-top:0.01rem"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label FormTit"><span></span>处理方式</p>
        <van-field disabled v-model="repairForm.handleTypeText" />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label FormTit"><span></span>处理数量</p>
        <div style="padding: 0.1rem 0.16rem;color:#c8c9cc;font-size: 0.14rem;">{{ numberTofixed(repairForm.num) }}{{ repairForm.reportWorkUnitText}}</div>
        <!-- <van-field disabled v-model="repairForm.num" /> -->
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label required FormTit"><span></span>返修工序</p>
        <van-field readonly placeholder="请选择" :is-link="!taskText" v-model="taskText" @click="visibles = true" >
            <div
              slot="right-icon"
              v-show="!!taskText"
              @click.stop="handleConfirm('')"
            >
              <img
                src="~@/assets/img/filedClear.png"
                alt=""
                style="width: 0.16rem"
              />
            </div>
          </van-field>
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label FormTit"><span></span>返修量</p>
        <!-- <van-field placeholder="根据选择的返修工序带出" disabled v-model="repairForm.repairNum" /> -->
        <div style="padding: 0.1rem 0.16rem;color:#c8c9cc;font-size: 0.14rem;" v-if="repairForm.repairNum">{{ numberTofixed(repairForm.repairNum) }}{{ repairForm.repairReportWorkUnitText}}</div>
        <div style="padding: 0.1rem 0.16rem;color:#c8c9cc;font-size: 0.14rem;" v-else>根据选择的返修工序带出</div>
      </van-cell-group>

      <van-cell-group style="margin-top: 0.1rem">
        <p class="label otherText">其他</p>
        <div class="bottomLine"></div>
        <p class="label">备注</p>
        <van-field
          v-model="repairForm.remark"
          rows="2"
          autosize
          label=""
          type="textarea"
          maxlength="500"
          placeholder="请输入备注"
          show-word-limit
        />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <upload
          :key="index"
          iconType="fj"
          @fileChange="fileChange"
          :fileIds="attachment"
        />
      </van-cell-group>
      <div class="search-bottoms">
        <!-- <span class="btnconfirm" @click="btnConfirm">确定</span> -->
        <van-button type="info" :loading="loadingSubmit" class="btnconfirm" loading-text="提交中..." @click="btnConfirm">提交</van-button>
      </div>
    </div>
    <van-popup v-model="visibles" position="bottom">
      <van-picker :columns="options" @confirm="handleConfirm" @cancel="visibles = false" show-toolbar />
    </van-popup>
    
  </div>
</template>
<script>
import Navbar from "@/components/navBar/navBar_right";
import upload from "@/components/upload/upload";
import { getFullProcessByOrderId, messNotQualityHandleIinfoDetailExecuteRepair } from '@/api/system'
import { numberTofixed } from '@/utils/util'
import BatchProduction from '@/components/BatchProduction'
export default {
  name: "materialRequisitionForm", //领料单
  components: {
    upload,
    Navbar,
    BatchProduction
  },

  data() {
    return {
      numberTofixed,
      index: "",
      attachment: "", //附件
      repairForm: {},
      visibles: false,
      options: [],
      taskText: '',
      loadingSubmit: false
    };
  },
  computed: {},
  mounted() {},
  created() {
    this.getDetail();
  },
  methods: {
    handleConfirm(v) {
      if(!v){
        this.repairForm.taskId = ''
      this.taskText = ''
      this.repairForm.repairNum = ''
      this.repairForm.repairReportWorkUnit = ''
      this.repairForm.repairTaskId = ''
      this.repairForm.repairReportWorkUnitText = ''
      this.visibles = false
      this.$forceUpdate()
      return
      }
      let pro = this.options.find(item => item.taskId == v.value)
      let { reportWorkRate, num } = this.repairForm
      let processWorkRate = pro.processWorkRate
      this.repairForm.taskId = v.value
      this.taskText = v.text
      this.repairForm.repairNum = (num / reportWorkRate)*processWorkRate
      this.repairForm.repairReportWorkUnit = pro.processWorkUnit
      this.repairForm.repairTaskId = v.value
      this.repairForm.repairReportWorkUnitText = pro.processWorkUnitText
      this.visibles = false
      console.log(v);
    },
    getDetail() {
      this.repairForm = {
        ...this.$route.query.formData,
        attachment: ''
      }
      getFullProcessByOrderId({orderId: this.repairForm.orderId, taskId: this.repairForm.oldTaskId}).then(res => {
        if (res.result) {
          for (let i = 0; i < res.result.length; i++) {
            let t = res.result[i]
            t.text = t.processName
            t.value = t.taskId
            this.options.push(t)
          }
        }
      })
    },
    fileChange(v) {
      this.repairForm.attachment = v
    },
    // 表单提交
    btnConfirm() {
      if (!this.repairForm.taskId) {
        this.$toast('请选择工序')
        return
      }
      this.loadingSubmit = true
      messNotQualityHandleIinfoDetailExecuteRepair(this.repairForm).then(res => {
        if (res.code == 200) {
          this.$toast('返修成功！')
          this.$router.go(-1)
        } else {
          this.$toast(res.message)
        }
        this.loadingSubmit = false
      })
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/theme.scss";
@import "@/views/workManagement/materialRequisition/materialForm.scss";
.search-bottoms {
  width: 100%;
  height: 0.5rem;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0px;
  padding: 0rem 0.11rem;
  box-sizing: border-box;
  font-size: 0.16rem;
  font-weight: 500;
  z-index: 9;
  .btnconfirm {
    flex: 1;
    background: #1890ff;
    box-sizing: border-box;
    height: 0.39rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.03rem;
    color: #ffffff;
  }
}
</style>
